function qinticInOut(t) {
    if ( ( t *= 2 ) < 1 ) return 0.5 * t * t * t * t * t
    return 0.5 * ( ( t -= 2 ) * t * t * t * t + 2 )
}

module.exports = qinticInOut


//////////////////
// WEBPACK FOOTER
// ./~/eases/quint-in-out.js
// module id = 145
// module chunks = 35783957827783 255223432971881